import React from 'react';

// Styles & Assets
import styles from './GenerateQRDialog.module.css';
import { AiFillPrinter } from 'react-icons/ai';
import { MdEmail, MdShare } from 'react-icons/md';
import { ReactComponent as UpdateSvg } from '../../../assets/icons/update.svg';

// Language
import { useTranslation } from 'react-i18next';

// Other
import { QRCodeCanvas } from 'qrcode.react';


const GenerateQRDialog: React.FC<{
    qrCode: string | null |undefined
    handlePrintQR: () => void
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>
    onRegenerate?: () => void
    qrGeneratedAt?: string
}> = ({ setShowModal, qrCode, handlePrintQR, onRegenerate, qrGeneratedAt }) => {

    const { t } = useTranslation();

    return (
        <div className={`dialog ${styles.dialogContainer}`}>
            {qrCode !== undefined && qrCode !== null ?
                <>
                    <div className={styles.titleArea}>
                        <h1 className={styles.title}>{t('here_QR_code')}</h1>
                        <button className={`button ${styles.updateButton}`} onClick={() => onRegenerate?.()}>
                            {t('update')}
                            <UpdateSvg className={styles.updateIcon} />
                        </button>
                    </div>
                    <QRCodeCanvas
                        value={qrCode}
                        size={256}
                        level='L'
                        id='qr-code-patient'
                    />                    
                    <div className={styles.lastUpdateArea}>
                        <p className={styles.lastUpdateLabel}>{t('last_update_QR_code')}:</p>
                        <p>{qrGeneratedAt}</p>
                    </div>
                </>
                :
                <div>
                    <h1 className={styles.title}>{t('lost_QR')}</h1>
                </div>
            }
            <div className={styles.buttonsQR}>
                <button onClick={handlePrintQR} className={styles.buttonQR} disabled={qrCode === null || qrCode === undefined}>
                    <AiFillPrinter />
                    <span>{t('print')} QR</span>
                </button>
                <button className={`${styles.buttonInactive} ${styles.buttonQR}`}>
                    <MdEmail />
                    <span>{t('send_by_email')}</span>
                </button>
                <button className={`${styles.buttonInactive} ${styles.buttonQR}`}>
                    <MdShare />
                    <span>{t('share_link')}</span>
                </button>
            </div>
            <button onClick={() => setShowModal(false)} className='button'>{t('close')}</button>
        </div>
    );
};

export default GenerateQRDialog;